import {combineReducers} from '@reduxjs/toolkit';

import {mcpAccountEntitlementsStateSlice} from './slices/mcp-account-entitlements-state.slice';
import {mcpAccountEntitlementsSlice} from './slices/mcp-account-entitlements.slice';
import {mcpUserEntitlementsStateSlice} from './slices/mcp-user-entitlements-state.slice';
import {mcpUserEntitlementsSlice} from './slices/mcp-user-entitlements.slice';

export const mcpUserEntitlementsAssignedReducer = combineReducers({
    userEntitlements: combineReducers({
        entitlements: mcpUserEntitlementsSlice.reducer,
        state: mcpUserEntitlementsStateSlice.reducer,
    }),
    accountEntitlements: combineReducers({
        entitlements: mcpAccountEntitlementsSlice.reducer,
        state: mcpAccountEntitlementsStateSlice.reducer,
    }),
});
